// IMAGENES dataNuestrosServicios
import iconosServ from '../img/nuestros-servicios/iconos-serv.png'
import iconosServ1 from '../img/nuestros-servicios/iconos-serv1.png'
import iconosServ2 from '../img/nuestros-servicios/iconos-serv2.png'
import iconosServ3 from '../img/nuestros-servicios/iconos-serv3.png'
import iconosServ4 from '../img/nuestros-servicios/iconos-serv4.png'
import iconosServ5 from '../img/nuestros-servicios/iconos-serv5.png'

//IMAGENES NUESTROS CLIENTES
import cliente1 from '../img/nuestros-clientes/cliente1.png'
import cliente2 from '../img/nuestros-clientes/cliente2.png'
import cliente3 from '../img/nuestros-clientes/cliente3.png'
import cliente4 from '../img/nuestros-clientes/cliente4.png'
import cliente5 from '../img/nuestros-clientes/cliente5.png'
import cliente6 from '../img/nuestros-clientes/cliente6.png'
import cliente7 from '../img/nuestros-clientes/cliente7.png'
import cliente8 from '../img/nuestros-clientes/cliente8.png'
import cliente9 from '../img/nuestros-clientes/cliente9.png'
// import cliente10 from '../img/nuestros-clientes/cliente10.png'
import cliente11 from '../img/nuestros-clientes/cliente11.png'
import cliente12 from '../img/nuestros-clientes/cliente12.png'
// import cliente13 from '../img/nuestros-clientes/cliente13.png'
// import cliente14 from '../img/nuestros-clientes/cliente14.png'
import cliente15 from '../img/nuestros-clientes/cliente15.png'
import cliente16 from '../img/nuestros-clientes/cliente16.png'

// IMAGENES homeBanner
import img1 from '../img/home-carousel/img1.png'
import img2 from '../img/home-carousel/img2.png'
import img3 from '../img/home-carousel/img3.png'
import img1D from '../img/home-carousel/img1-desktop.png'
import img2D from '../img/home-carousel/img2-desktop.png'
import img3D from '../img/home-carousel/img3-desktop.png'



export const dataNuestrosServicios = [
    {
        imgData:iconosServ,
        title:`ALARMAS 
        PARA HOGAR O 
        COMERCIO`,
        text: 'Instalación de equipos de seguridad diseñados a medida.'
    },
    {
        imgData: iconosServ1,
        title:`CÁMARAS DE 
        VIGILANCIA`,
        text: 'Instalación de cámaras de vigilancia y acceso web para que puedas visualizarlas en tiempo real y desde cualquier dispositivo.'
    },
    {
        imgData: iconosServ2,
        title:`RESPUESTA 
        MÓVIL`,
        text: 'Amplia flota de vehículos para una respuesta rápida y eficaz.'
    },
    {
        imgData: iconosServ3,
        title:`MONITOREO 
        ACTIVO 
        24/7`,
        text: 'Central de monitoreo funcionando hace más de 30 años.'
    },
    {
        imgData: iconosServ4,
        title:`SERVICIO 
        TÉCNICO 
        LAS 24HS`,
        text: 'Contamos con personal ampliamente capacitado para solucionar cualquier inconveniente de manera rápida.'
    },
    {
        imgData: iconosServ5,
        title:`RASTREO 
        SATELITAL`,
        text: 'Instalación de GPS y control de flotas.'
    },
]
export const homeBanner = [
    {
        imgData:img1,
        btnName: 'Más información',
        btnLink: 'videoverificación-inteligente'
    },
    {
        imgData:img2,
        btnName: 'Cotizar',
        btnLink: 'cotizar'
    },
    {
        imgData:img3,
        btnName: 'Ver Video',
        btnLink: 'quiénes-somos'
    },
]
export const homeBannerDesktop = [
    {
        imgData:img1D,
        btnName: 'Más información',
        btnLink: 'videoverificación-inteligente'
    },
    {
        imgData:img2D,
        btnName: 'Cotizar',
        btnLink: 'cotizar'
    },
    {
        imgData:img3D,
        btnName: 'Ver Video',
        btnLink: 'quiénes-somos'
    },
]
export const nuestrosClientesData = [
    cliente1,
    cliente2,
    cliente3,
    cliente4,
    cliente5,
    cliente6,
    cliente7,
    cliente8,
    cliente9,
    cliente11,
    cliente12,
    cliente15,
    cliente16
]
export const opinionesData = [
    {
        owner: 'Rodolfo N. B.',
        review: 'Excelente atención, muy buena predisposición del personal y eficientes en su trabajo. Por demás recomendable.',
    },
    {
        owner: 'Marcelo O.',
        review: 'Recomiendo ampliamente los servicios de seguridad de Vicar. He sido cliente durante más de 30 años y siempre he estado satisfecho con su servicio profesional y confiable.',
    },
    {
        owner: 'Mirta Q.',
        review: 'Quiero agradecer por la atención que nos brindaron! Y por la atención del equipo de técnicos! Como siempre muy correctos y amables!!! Muchas gracias por todo!!!',
    },
    {
        owner: 'Clara M.',
        review: 'Queria agradecerles al equipo técnico de Vicar por el buen trabajo y buena predisposición. Pudieron resolver todo con inteligencia y ganas.',
    },
    {
        owner: 'Marcelo D. L.',
        review: 'Excelente servicio!!! Atención humana, rápida respuesta, por más empresas como Vicar seguridad!!!',
    },
    {
        owner: 'Jorge R.',
        review: 'Seriedad y confiabilidad luego de varios años de contratar el servicio con la empresa',
    },
    {
        owner: 'Cristian D. L.',
        review: 'Una empresa responsable y que presta un servicio muy bueno.',
    }
]